// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pesquisar_wrapper__1WA1i","input":"pesquisar_input__1kt_S","label":"pesquisar_label__2rEtE","error":"pesquisar_error__2QPIO"};